import { SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_BOLD } from '@oneaudi/unified-web-alpha-common';
import type { ThemeName } from '@oneaudi/unified-web-alpha-common/dist/cjs/components/theme-provider/theme';
import { CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_BOLD } from '@oneaudi/unified-web-common';

type GetDesignLibraryProps = {
  unifiedWebCommonVersion?: string;
  unifiedWebAlphaCommonVersion?: string;
};

export const getDesignLibrary = (props?: GetDesignLibraryProps): { [key: string]: string } => {
  if (process.env.IS_LEGACY) {
    return {
      '@oneaudi/unified-web-common': props?.unifiedWebCommonVersion || '*',
    };
  }
  return {
    '@oneaudi/unified-web-alpha-common': props?.unifiedWebAlphaCommonVersion || '*',
  };
};
export const getTypographyToken = () => {
  if (process.env.IS_LEGACY) {
    return CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_BOLD;
  }
  return SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_BOLD;
};
export const getThemeName = (defaultThemeName?: ThemeName): ThemeName => {
  if (process.env.IS_LEGACY) {
    return defaultThemeName || 'light';
  }
  return 'dark';
};
